import { navLinks, siteName } from '@/mocks/comicData';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-4 md:px-6 md:py-16">
        <div className="md:col-span-2">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-store-2-line text-xl" />
            </span>
            <span className="font-heading text-lg font-bold text-white">{siteName}</span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            一个专注于《洞洞杂货铺漫画》剧情解析的内容站点，为你整理分卷剧情、角色脉络、结局走向与最新章节动态，让你一页看懂这部奇幻治愈系作品到底讲了什么。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {[
              { icon: 'ri-mail-line', label: 'contact@dongdong-store.example' },
              { icon: 'ri-global-line', label: '简体中文' },
            ].map((item) => (
              <span key={item.icon} className="inline-flex items-center gap-2 text-xs text-background-300">
                <i className={`${item.icon} text-primary-300`} />
                {item.label}
              </span>
            ))}
          </div>
        </div>

        <nav aria-label="栏目导航">
          <h3 className="font-heading text-sm font-bold tracking-wider text-white">内容栏目</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} className="text-sm text-background-300 transition-colors hover:text-primary-300">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-wider text-white">阅读指引</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            <li><a href="#story" className="text-sm text-background-300 transition-colors hover:text-primary-300">剧情主线梳理</a></li>
            <li><a href="#volumes" className="text-sm text-background-300 transition-colors hover:text-primary-300">分卷剧情详情</a></li>
            <li><a href="#ending" className="text-sm text-background-300 transition-colors hover:text-primary-300">结局走向解析</a></li>
            <li><a href="#faq" className="text-sm text-background-300 transition-colors hover:text-primary-300">常见问题解答</a></li>
            <li><a href="#updates" className="text-sm text-background-300 transition-colors hover:text-primary-300">最新章节更新</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-700/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 sm:flex-row md:px-6">
          <p className="text-center text-xs text-background-400">
            © {year} {siteName} · 内容整理自公开连载信息，仅供读者交流参考
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-background-300 transition-colors hover:text-primary-300"
          >
            <i className="ri-arrow-up-line" />
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}